import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

export const SkillsForm = ({ data, onChange }) => {
  const [newSkill, setNewSkill] = useState('');

  const addSkill = (e) => {
    e.preventDefault();
    if (newSkill.trim() && !data.includes(newSkill.trim())) {
      onChange([...data, newSkill.trim()]);
      setNewSkill('');
    }
  };

  const removeSkill = (skillToRemove) => {
    onChange(data.filter(skill => skill !== skillToRemove));
  };

  return (
    <div className="space-y-6">
      <form onSubmit={addSkill} className="flex gap-2">
        <Input 
          value={newSkill} 
          onChange={(e) => setNewSkill(e.target.value)} 
          placeholder="Add a new skill (e.g. React)"
          className="flex-1"
        />
        <Button type="submit" disabled={!newSkill.trim()}>Add</Button>
      </form>

      <div className="flex flex-wrap gap-2 p-4 bg-gray-50 rounded-lg min-h-[100px] content-start">
        {data.length === 0 && <span className="text-gray-400 text-sm">No skills added yet.</span>}
        {data.map((skill) => (
          <div key={skill} className="flex items-center bg-white border border-gray-200 px-3 py-1 rounded-full shadow-sm text-sm">
            <span className="mr-2">{skill}</span>
            <button onClick={() => removeSkill(skill)} className="text-gray-400 hover:text-red-500">
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
